import type { CharacterOption } from './types';

export const CHARACTERS: CharacterOption[] = [
  {
    id: 'ash',
    name: 'Ash for People',
    image: '/players/player-ash.png',
    reactions: {
      idle: '/players/player-ash.png',
      happy: '/players-reactions/player-ash-happy.png',
      sad: '/players-reactions/player-ash-sad.png',
    },
  },
  {
    id: 'finn',
    name: 'Finn for Planet',
    image: '/players/player-finn.png',
    reactions: {
      idle: '/players/player-finn.png',
      happy: '/players-reactions/player-finn-happy.png',
      sad: '/players-reactions/player-finn-sad.png',
    },
  },
  {
    id: 'mei',
    name: 'Mei for Prosperity',
    image: '/players/player-mei.png',
    reactions: {
      idle: '/players/player-mei.png',
      happy: '/players-reactions/player-mei-happy.png',
      sad: '/players-reactions/player-mei-sad.png',
    },
  },
  {
    id: 'lily',
    name: 'Lily for Peace',
    image: '/players/player-lily.png',
    reactions: {
      idle: '/players/player-lily.png',
      happy: '/players-reactions/player-lily-happy.png',
      sad: '/players-reactions/player-lily-sad.png',
    },
  },
  {
    id: 'sari',
    name: 'Sari for Partnerships',
    image: '/players/player-sari.png',
    reactions: {
      idle: '/players/player-sari.png',
      happy: '/players-reactions/player-sari-happy.png',
      sad: '/players-reactions/player-sari-sad.png',
    },
  },
];

export const GUARDIAN_IMAGES: Record<string, string> = {
  'Guardian of People': '/guardians/guardian-people.png',
  'Guardian of Planet': '/guardians/guardian-planet.png',
  'Guardian of Prosperity': '/guardians/guardian-prosperity.png',
  'Guardian of Peace': '/guardians/guardian-peace.png',
  'Guardian of Partnership': '/guardians/guardian-partnerships.png',
};

export const QUESTIONS_PER_ROUND = 5;
export const SHORT_STARTING_STABILITY = 50;
export const LONG_STARTING_STABILITY = 100;
export const DEATH_THRESHOLD = 0;
